<template>
  <div>
    <v-row class="py-0">
      <v-col cols="6">
        <h3 class="title dw_green--text font-weight-light">
          <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiPoundBox" />
          Add a Tag
        </h3>
        <v-form ref="addTagForm" v-model="formValid" @submit.prevent>
          <v-card flat color="bg_dark">
            <v-card-text class="px-4 py-0">
              <v-text-field
                v-model="newTag"
                :counter="256"
                placeholder="Add a new tag here *"
                color="dw_green"
                :rules="rules"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="button"
                @click="resetForm"
                color="dw_green"
                x-small
                text>Clear</v-btn>
              <v-btn
                type="submit"
                :disabled="!formValid"
                @click="addTag"
                color="dw_green"
                small
                outlined>
                Add
                <v-icon small color="dw_green" class="ml-1" v-text="mdiPound" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="6">
        <tag-list />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mdiPound, mdiPoundBox, mdiMagnify } from '@mdi/js';
import { mapActions } from 'vuex';
import tagList from '@/components/forms/simpleLists/tagList.vue';
import utils from '@/utils/index';

export default {
  name: 'addTag',
  components: {
    tagList
  },
  data() {
    return {
      mdiPound,
      mdiPoundBox,
      mdiMagnify,
      formValid: false,
      newTag: ''
    };
  },
  computed: {
    rules() {
      return [
        utils.validationRules.required,
        utils.validationRules.min,
        utils.validationRules.max,
        utils.validationRules.textRegex
      ];
    }
  },
  methods: {
    ...mapActions([
      'fetchTagOptions',
      'createTag'
    ]),
    async addTag() {
      try {
        await this.createTag({ name: this.newTag });
        this.fetchTagOptions();
        this.resetForm();
      } catch (err) {
        console.error(err);
      }
    },
    resetForm() {
      this.newTag = '';
      this.$refs.addTagForm.resetValidation();
    }
  }
};
</script>
